'use client'

import { useEffect } from 'react'
import {
  useAccountEffect,
  useDisconnect,
  useSignMessage,
} from 'wagmi'

import { TOKEN } from '@/constants/local-storage'
import { setToken } from '@/redux/global-actions'
import {
  ChallengeType,
  useChallengeMutation,
  useLazyReadMineUserQuery,
  useLoginMutation,
} from '@/redux/user'
import {
  useAppDispatch,
  useAppSelector,
} from '@/redux/utils'
import { useLazyReadAllWalletsQuery } from '@/redux/wallet'

export default function Init() {
  const { disconnect } = useDisconnect()
  const [readMineUser] = useLazyReadMineUserQuery()
  const { signMessageAsync } = useSignMessage()
  const [challenge] = useChallengeMutation()
  const [login] = useLoginMutation()
  const dispatch = useAppDispatch()
  const [readAllWallet] = useLazyReadAllWalletsQuery()
  const token = useAppSelector((state) => state.global.token)

  useEffect(() => {
    dispatch(setToken(window.localStorage.getItem(TOKEN) || undefined))
    console.log(`Version: ${process.env.NEXT_PUBLIC_APP_VERSION}`)
  }, [dispatch])

  useAccountEffect({
    onConnect: async ({ address, connector }) => {
      if (token) return
      const { data: challengeData } = await challenge({ address, type: ChallengeType.Login })
      if (!challengeData) return
      try {
        const signedMessage = await signMessageAsync({ message: challengeData.message })
        console.log(connector)
        const { id, name, icon } = connector
        const { data: loginData } = await login({
          address,
          signedMessage,
          walletId: id,
          walletName: name,
          walletLogo: icon,
        })
        if (!loginData) return
        dispatch(setToken(loginData.token))
        window.localStorage.setItem(TOKEN, loginData.token)
        readMineUser()
        readAllWallet()
      } catch (error) {
        dispatch(setToken(undefined))
        disconnect()
        console.log(error)
      }
    },
    onDisconnect: () => window.localStorage.removeItem(TOKEN),
  })
  return null
}
